import { AppInfo } from '@capacitor/app';
import { DeviceInfo } from '@capacitor/device';
import { createAction, props } from '@ngrx/store';

export const loadDeviceInfo = createAction('[Device] Load Device Info');

export const loadDeviceInfoSuccess = createAction(
  '[Device] Load Device Info Success',
  props<{
    payload: {
      info: DeviceInfo;
      uuid: string;
    };
  }>()
);

export const loadDeviceInfoFailure = createAction(
  '[Device] Load Device Info Failure',
  props<{
    payload: { error: Error };
  }>()
);

export const loadAppInfoSuccess = createAction(
  '[Device] Load App Info Success',
  props<{ payload: { appInfo: AppInfo } }>()
);

export const loadAppInfoFailure = createAction(
  '[Device] Load App Info Failure',
  props<{ payload: { error: Error } }>()
);

export const updateDeviceDimensions = createAction(
  '[Device] Update Device Dimensions',
  props<{
    payload: {
      height: number;
      width: number;
    };
  }>()
);
